import axios from "axios";

export const PORTAL_API = `${process.env.REACT_APP_BACKEND_URL}/api/portal`;

// Portal uses JWT bearer stored in localStorage (fallback) + httpOnly cookie (primary).
// Staff-initiated read-only impersonation stores a short-lived token in sessionStorage
// (tab-scoped) and takes precedence over both.
const TOKEN_KEY = "formc_portal_token";
const IMPERSONATION_KEY = "formc_portal_impersonation_token";

export function getPortalToken() {
  return localStorage.getItem(TOKEN_KEY);
}

export function setPortalToken(token) {
  if (token) localStorage.setItem(TOKEN_KEY, token);
  else localStorage.removeItem(TOKEN_KEY);
}

export function getImpersonationToken() {
  return sessionStorage.getItem(IMPERSONATION_KEY);
}

export function clearImpersonationToken() {
  sessionStorage.removeItem(IMPERSONATION_KEY);
}

export function isImpersonating() {
  return Boolean(sessionStorage.getItem(IMPERSONATION_KEY));
}

export const portalApi = axios.create({
  baseURL: PORTAL_API,
  withCredentials: true,
});

portalApi.interceptors.request.use((config) => {
  // Impersonation wins: send only the Bearer token and skip cookies so the
  // staff's own portal session (if any) is never mixed with the preview.
  const impersonation = getImpersonationToken();
  if (impersonation) {
    config.headers.Authorization = `Bearer ${impersonation}`;
    config.withCredentials = false;
    return config;
  }
  const token = getPortalToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function formatPortalError(err) {
  const d = err?.response?.data?.detail;
  if (!d) return err?.message || "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d))
    return d.map((e) => (e?.msg ? e.msg : JSON.stringify(e))).join(" · ");
  if (d?.msg) return d.msg;
  return String(d);
}
